import * as actionTypes from 'constants/ActionTypes';

export function getCountries() {
    return {
        type: actionTypes.GET_COUNTRIES.REQUEST,
    };
}


// WEBPACK FOOTER //
// ./app/actions/countries.js